import React, { useState, useEffect } from "react";
import styled from "styled-components";
import colors from "styles/colors";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import facebookActions from "modules/facebook/actions";
import facebookSelectors from "modules/facebook/selectors";

const FacebookFormList = ({ errorStatus, action, leadFormId }) => {
  const dispatch = useDispatch();
  const [t] = useTranslation();
  const facebookFormListResult = useSelector((state) => facebookSelectors.getFacebookFormListResult(state));
  const setCheckedFormItemsResult = useSelector((state) => facebookSelectors.setCheckedFormItemsResult(state));
  const changePageFormSelectTypeResult = useSelector((state) =>
    facebookSelectors.changePageFormSelectTypeResult(state),
  );
  const facebookPageSettingResult = useSelector((state) => facebookSelectors.getFacebookPageSettingResult(state));
  const duplicateFacebookFormResult = useSelector((state) => facebookSelectors.setDuplicateFacebookFormResult(state));
  const facebookFormLoading = useSelector((state) => facebookSelectors.setFacebookFormLoadingResult(state));
  const [checkedItems, setCheckedItems] = useState([]);
  const [selectedRadioValue, setSelectedRadioValue] = useState();

  useEffect(() => {
    const savedValue = localStorage.getItem("radioValue");
    if (savedValue) {
      setSelectedRadioValue(savedValue);
    } else {
      setSelectedRadioValue("all");
    }
  }, [localStorage.getItem("radioValue")]);

  useEffect(() => {
    let formList;
    if (changePageFormSelectTypeResult.data.pageFormSelectType === "all") {
      formList = null;
    } else if (changePageFormSelectTypeResult.data.pageFormSelectType === "select") {
      formList = setCheckedFormItemsResult.data.checkedFormItems;
    }

    if (formList) {
      setCheckedItems(formList);
    } else if (formList === null) {
      setCheckedItems([]);
    }
  }, [changePageFormSelectTypeResult, setCheckedFormItemsResult]);

  /** action when select custom radio */
  const handleSelect = async (type) => {
    let newValue = type;
    setSelectedRadioValue(newValue);
    localStorage.setItem("radioValue", newValue);
    await dispatch(facebookActions.changePageFormSelectType(type));
    await dispatch(facebookActions.setValidateFacebookLeadForm({ result: false }));
    if (type == "all") {
      handleSelectAll();
    } else if (type == "select") {
      setCheckedItems([]);
      await dispatch(facebookActions.setCheckedFormItems([]));
    }
  };

  /** action when check box
   * @param {string} itemId
   * @param {object} event
   */
  const handleOnChange = async (itemId, event) => {
    let newCheckedItems;
    if (event.target.checked) {
      newCheckedItems = [...checkedItems, itemId];
    } else {
      newCheckedItems = checkedItems.filter((item) => item !== itemId);
    }
    setCheckedItems(newCheckedItems);
    await dispatch(facebookActions.changePageFormSelectType("select"));
    await dispatch(facebookActions.setCheckedFormItems(newCheckedItems));
    await dispatch(facebookActions.setValidateFacebookLeadForm({ result: false }));
  };

  /** action when click select all */
  const handleSelectAll = async () => {
    let newCheckedItems = [];
    setCheckedItems(newCheckedItems);
    await dispatch(facebookActions.setCheckedFormItems(newCheckedItems));
  };

  const FormContainer = () => {
    return (
      <FormListContainer errorStatus={errorStatus}>
        {facebookFormListResult.result === 0 && !facebookFormLoading.data.loading ? (
          facebookFormListResult.data.formList != null ? (
            duplicateFacebookFormResult.data.duplicateForm.duplicate == "all" ? (
              <TextWarning>{t("__fbleads_fb_form_used_all_form")}</TextWarning>
            ) : action == "add" && facebookFormListResult.data.formStatus == "ALLUSED" ? (
              <TextWarning>{t("__fbleads_fb_form_used_all_form")}</TextWarning>
            ) : action == "edit" &&
              facebookFormListResult.data.formStatus == "ALLUSED" &&
              facebookPageSettingResult.result === 0 &&
              facebookPageSettingResult.msg === "GET_DATA_COMPLETED" &&
              facebookPageSettingResult.data.leadForm.length == 0 ? (
              <TextWarning>{t("__fbleads_fb_form_used_all_form")}</TextWarning>
            ) : (
              <>
                {duplicateFacebookFormResult.data.duplicateForm.duplicate != "all" &&
                duplicateFacebookFormResult.data.duplicateForm.duplicate != null &&
                duplicateFacebookFormResult.data.duplicateForm.duplicate.length > 0
                  ? null
                  : facebookFormListResult.data.formStatus != "SOMEUSED" && (
                      <div className="radio-group">
                        <RadioAllButton>
                          <div
                            className={`radio-button ${selectedRadioValue === "all" ? "selected" : ""}`}
                            onClick={() => handleSelect("all")}
                          >
                            <div
                              className={`radio-in-button ${selectedRadioValue === "all" ? "selected-in" : ""}`}
                            ></div>
                          </div>
                          <label className="cursor-pointer radio-all-label" htmlFor="fb_form_input_all">
                            <span>{t("__all")}</span>
                            <span className="label-describe">{t("__fbleads_fb_all_forn_describe")}</span>
                          </label>
                        </RadioAllButton>
                        <RadioButton>
                          <div
                            className={`radio-button ${selectedRadioValue === "select" ? "selected" : ""}`}
                            onClick={() => handleSelect("select")}
                          >
                            <div
                              className={`radio-in-button ${selectedRadioValue === "select" ? "selected-in" : ""}`}
                            ></div>
                          </div>
                          <label className="cursor-pointer" htmlFor="fb_form_input_custom">
                            {t("__custom")}
                          </label>
                        </RadioButton>
                      </div>
                    )}

                {facebookFormListResult.data.formList.map((item, index) => {
                  return (item.status.includes("ARCHIVED") && !item.status.includes("USED")) ||
                    (action == "add" && item.status.includes("ARCHIVED") && item.status.includes("USED")) ? null : (
                    <CheckBoxLabel
                      key={index}
                      formStatus={
                        facebookFormListResult.data.formStatus == "SOMEUSED" ||
                        duplicateFacebookFormResult.data.duplicateForm.duplicate != null
                      }
                    >
                      <MainLabel>
                        <input
                          className={`form-checkbox ${
                            selectedRadioValue == "all" ||
                            (facebookFormListResult.data.formStatus != "ALLUSED" &&
                              item.status.includes("USED") &&
                              item.facebook_leadform_setting_id != leadFormId) ||
                            (duplicateFacebookFormResult.data.duplicateForm.duplicate != null &&
                              duplicateFacebookFormResult.data.duplicateForm.duplicate != "all" &&
                              duplicateFacebookFormResult.data.duplicateForm.duplicate.includes(item.id))
                              ? ""
                              : "cursor-pointer "
                          }`}
                          id={`fb-form-input-${index}`}
                          type="checkbox"
                          name={`fb-form-input-${index}`}
                          onChange={(event) => handleOnChange(item.id, event)}
                          checked={checkedItems.includes(item.id)}
                          form="save_page"
                          disabled={
                            selectedRadioValue == "all" ||
                            (facebookFormListResult.data.formStatus != "ALLUSED" &&
                              item.status.includes("USED") &&
                              item.facebook_leadform_setting_id != leadFormId) ||
                            (duplicateFacebookFormResult.data.duplicateForm.duplicate != null &&
                              duplicateFacebookFormResult.data.duplicateForm.duplicate != "all" &&
                              duplicateFacebookFormResult.data.duplicateForm.duplicate.includes(item.id))
                          }
                        />
                        <label
                          className={`form-label ${
                            (facebookFormListResult.data.formStatus != "ALLUSED" &&
                              item.status.includes("USED") &&
                              item.facebook_leadform_setting_id != leadFormId) ||
                            (duplicateFacebookFormResult.data.duplicateForm.duplicate != null &&
                              duplicateFacebookFormResult.data.duplicateForm.duplicate != "all" &&
                              duplicateFacebookFormResult.data.duplicateForm.duplicate.includes(item.id))
                              ? "disabled-form"
                              : "cursor-pointer"
                          }`}
                          htmlFor={`fb-form-input-${index}`}
                        >
                          <FBFormLabel>
                            <span className="leadform-name">{item.name}</span>
                          </FBFormLabel>
                        </label>
                      </MainLabel>
                      <SubLabel>
                        <div className="leadform-id">
                          {t("__form_id")}: {item.id}
                        </div>
                        {((facebookFormListResult.data.formStatus != "ALLUSED" &&
                          item.status.includes("USED") &&
                          item.facebook_leadform_setting_id != leadFormId) ||
                          (duplicateFacebookFormResult.data.duplicateForm.duplicate != null &&
                            duplicateFacebookFormResult.data.duplicateForm.duplicate != "all" &&
                            duplicateFacebookFormResult.data.duplicateForm.duplicate.includes(item.id))) && (
                          <span className="form-describe">({t("__used")})</span>
                        )}
                        {item.status.includes("ARCHIVED") && <span className="form-describe">({t("__deleted")})</span>}
                      </SubLabel>
                    </CheckBoxLabel>
                  );
                })}
              </>
            )
          ) : (
            <TextWarning>{t("__fbleads_fb_form_not_found")}</TextWarning>
          )
        ) : facebookFormLoading.data.loading ? (
          <LoadingArea>
            <StyledLoadingIcon></StyledLoadingIcon>
          </LoadingArea>
        ) : null}
      </FormListContainer>
    );
  };
  return <>{FormContainer()}</>;
};

export default FacebookFormList;

const LoadingArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  width: 100%;
  height: 180px;
`;

const StyledLoadingIcon = styled.div`
  border: 5px solid #ccc;
  border-top: 5px solid #eee;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  animation: button-keyframe-spin 1s linear infinite;
  box-sizing: initial !important;
  position: sticky;

  @keyframes button-keyframe-spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const FormListContainer = styled.div.attrs((props) => ({
  border: props.errorStatus ? `1px solid ${colors.negative}` : "1px solid #ddd",
}))`
  border: ${(props) => props.border};
  border-radius: 8px;
  margin: 0;
  padding: 10px 16px;
  height: 170px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  font-size: 14px;
  font-family: "Poppins", "Kanit", "Helvetica Neue", sans-serif;
  color: #555;

  .radio-group {
    position: relative;
  }

  & > *:not(:first-child) {
    margin-top: 10px;
  }
`;

const CheckBoxLabel = styled.div.attrs((props) => ({
  marginLeft: props.formStatus ? "0" : "24px",
}))`
  margin-left: ${(props) => props.marginLeft};
  display: flex;
  flex-direction: column;
`;

const MainLabel = styled.div`
  display: flex;
  align-items: flex-start;
  flex-flow: row nowrap;
  .form-checkbox {
    position: relative;
    top: 4px;
    margin-right: 10px;
    flex-basis: fit-content;
  }
  .leadform-name {
    margin-right: 5px;
    word-break: break-word;
    line-height: 1.5rem;
  }
  .disabled-form {
    color: #aaa;
  }
`;

const FBFormLabel = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
`;

const SubLabel = styled.div`
  display: flex;
  flex-flow: row wrap;
  margin-left: 27px;
  .leadform-id {
    font-size: 12px;
    color: #aaa;
    line-height: 1.5rem;
    margin-right: 5px;
  }
  .form-describe {
    font-style: italic;
    font-size: 12px;
    color: #aaa;
    line-height: 1.5rem;
    margin-right: 5px;
  }
`;

const RadioAllButton = styled.span`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  cursor: pointer;
  .radio-button {
    width: 13px;
    height: 13px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid darkgrey;
    border-radius: 50%;
    top: 5px;
    margin-right: 10px;
  }
  .selected {
    border: 1px solid #1578f1;
  }

  .radio-in-button {
    width: 10px;
    height: 10px;
    position: relative;
    border: 1px solid #fff;
    border-radius: 50%;
    left: 0.2px;
  }
  .selected-in {
    background-color: #1578f1;
  }
  .radio-all-label {
    display: flex;
    flex-direction: column;
    line-height: 1rem;
    position: relative;
    top: 3px;
  }
  .label-describe {
    font-size: 12px;
    color: #aaa;
  }
  &:first-child {
    margin-right: 10px;
  }
`;

const RadioButton = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  .radio-button {
    width: 13px;
    height: 13px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid darkgrey;
    border-radius: 50%;
    margin-right: 10px;
  }
  .selected {
    border: 1px solid #1578f1;
  }

  .radio-in-button {
    width: 10px;
    height: 10px;
    position: relative;
    border: 1px solid #fff;
    border-radius: 50%;
    left: 0.2px;
  }

  .selected-in {
    background-color: #1578f1;
  }

  &:first-child {
    margin-right: 10px;
  }
`;

const TextWarning = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  color: #aaa;
  font-size: 14px;
  font-weight: normal;
`;
